// Zustand store pro aktualne bezici smenu.

import { create } from "zustand";
import type { Shift } from "@routera/shared";
import { api } from "../lib/api";

interface ShiftState {
  shift: Shift | null;
  loading: boolean;

  /** Pri startu app — overit zda existuje rozjeta smena (pro resume). */
  refresh: () => Promise<void>;

  /** Po POST /shift/start — ulozit shift do state. */
  setShift: (shift: Shift) => void;

  /** Po POST /shift/{id}/end — vymazat ze state. */
  clear: () => void;
}

export const useShiftStore = create<ShiftState>((set) => ({
  shift: null,
  loading: false,

  refresh: async () => {
    set({ loading: true });
    try {
      const s = await api.shift.active();
      set({ shift: s, loading: false });
    } catch {
      set({ loading: false });
    }
  },

  setShift: (shift) => set({ shift }),
  clear: () => set({ shift: null }),
}));
